import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/site/primitives";

export const Steps = () => {
  const { t } = useLang();
  return (
    <section className="relative py-28 sm:py-36" data-testid="steps-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>{t.steps.eyebrow}</Eyebrow>
          <h2 className="mt-5 font-display font-light text-sand text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            {t.steps.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6 items-stretch">
          {t.steps.items.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="h-full">
              <div className="group relative h-full rounded-2xl border border-gold/20 bg-ivy/40 p-8 transition-colors duration-500 hover:border-gold/50">
                <div className="font-display text-gold/90 text-6xl leading-none">{s.n}</div>
                <h3 className="mt-6 font-editorial italic text-sand text-2xl">{s.t}</h3>
                <div className="mt-4 space-y-3">
                  {s.p.map((para, j) => (
                    <p key={j} className="text-sand/70 text-sm leading-relaxed font-light">{para}</p>
                  ))}
                </div>
                {s.ladder && (
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.ladder.map(([price, label], k) => (
                      <div key={k} className="rounded-lg border border-gold/25 bg-espresso/50 px-3 py-1.5 text-center">
                        <span className="font-display text-gold text-base">{price}</span>
                        <span className="block text-sand/50 text-[11px] tracking-wide">{label}</span>
                      </div>
                    ))}
                  </div>
                )}
                <div className="mt-8 h-px w-full bg-gradient-to-r from-gold/40 to-transparent group-hover:from-gold/70 transition-colors" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
